import script from "./TerminosCondiciones.vue?vue&type=script&setup=true&lang=js"
export * from "./TerminosCondiciones.vue?vue&type=script&setup=true&lang=js"

import "./TerminosCondiciones.vue?vue&type=style&index=0&id=81730c18&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81730c18"]])

export default __exports__